import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import Slider from "react-slick";

function SpinAndRuleJiliSlotsPromo(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const settings = {
        loop: true,
        arrows: true,
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        centerPadding: '20px'
    };

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    <p>This July to August, spin your way to the top with <span className='boldText'>FOMO7 </span>and <span className='boldText'>JILI Slots!</span> Join the action-packed “Spin & Rule” leaderboard challenge and win. The more you spin, the higher you rank!</p>
                </TitleText>
                <Divider></Divider>
                <ImageContainer>
                    <HeadingTwoWrapper>
                        <h2>How to Participate</h2>
                        <UnderLine />
                    </HeadingTwoWrapper>
                    <ImageWrapper>
                        <Cards>
                            <Card>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoCardImgOne}`}
                                    alt="spin and rule jili slots"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p><span className='boldText'>Log in</span> to your FOMO7 account</p>
                            </Card>
                            <Card>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoCardImgTwo}`}
                                    alt="spin and rule jili slots"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p><span className='boldText'>Open the JILI Slots section</span> in the casino lobby</p>
                            </Card>
                            <Card>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoCardImgThree}`}
                                    alt="spin and rule jili slots"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p><span className='boldText'>Place real money bets</span> on any JILI slot game</p>
                            </Card>
                        </Cards>
                        <Cards>
                            <Card>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoCardImgFour}`}
                                    alt="spin and rule jili slots"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p><span className='boldText'>Turnover = Points</span> — More bets, more rank!</p>
                            </Card>
                            <Card>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoCardImgFive}`}
                                    alt="spin and rule jili slots"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p><span className='boldText'>Track the leaderboard Weekly,</span> updated every 30 minutes.</p>
                            </Card>
                            <Card>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoCardImgSix}`}
                                    alt="spin and rule jili slots"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p><span className='boldText'>Finish in the Top 10 Weekly</span> or <span className='boldText'>Top 3 monthly</span> to win!</p>
                            </Card>
                        </Cards>
                    </ImageWrapper>
                </ImageContainer>
                <PriceBreakDown>
                    <HeadingTwoWrapper>
                        <h2>Weekly Prize Pool</h2>
                        <UnderLine />
                    </HeadingTwoWrapper>
                    <SliderWrapper>
                        <Slider {...settings}>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgOne}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgTwo}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgThree}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgFour}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgFive}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgSix}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgSeveen}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgEight}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgNine}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoPPCarouselImgTen}`} /></div>
                        </Slider>
                    </SliderWrapper>
                </PriceBreakDown>
                <MonthlyPrize>
                    <HeadingTwoWrapper>
                        <h2>Monthly Prize Pool</h2>
                        <UnderLine />
                    </HeadingTwoWrapper>
                    <LazyLoadImage
                        src={`${config.imageV3Host}/static/cashsite/${theme.image.spinRuleJiliPromoMPP}`}
                        alt="spin and rule jili slots"
                        effect="none"
                        placeholder={<PlaceholderImage />}
                    />
                    <p>(Random selector from top players in the weekly leaderboard)</p>
                </MonthlyPrize>
                <TermsAndCondition>
                    <HeadingTwoWrapper>
                        <h2>Terms & Conditions</h2>
                        <UnderLine />
                    </HeadingTwoWrapper>
                    <ol>
                        <li>Only real money bets on <span className='boldText'>JILI Slots</span> qualify.</li>
                        <li>Leaderboard ranks are based purely on turnover.</li>
                        <li>Weekly prizes are paid as bonuses.</li>
                        <li>Winners must complete KYC and provide a valid USDT wallet address if required.</li>
                        <li>Leaderboards refresh Weekly at midnight IST.</li>
                        <li>KYC verification required for all payouts.</li>
                        <li>Players using unfair means will be disqualified.</li>
                        <li>FOMO7 holds full rights to amend or cancel the promotion.</li>
                    </ol>
                </TermsAndCondition>
                <Divider></Divider>
                <BottomContent>
                    <p>Start spinning JILI's thrilling slots on FOMO7 - and rule the leaderboard!</p>
                </BottomContent>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(SpinAndRuleJiliSlotsPromo));

//Styled Component.
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #FED546;  
    display: flex;
    flex-direction: column;
//     background: ${theme('palette.EvolutionCPDMainBg')};
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.spinRuleJiliPromoBackgroundImg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    .boldText {
        color: #FEBA3B;
        font-weight: 700;
    }
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1.5rem 0 3rem 0;
    position: relative;

    p {
        width: 60%;
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px; /* 162.5% */
        text-transform: capitalize;
        margin: 0;
    }
`;

const HeadingTwoWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;

    h2 {
        text-align: center;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: 107.7%; /* 26.925px */
        letter-spacing: 1.25px;
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 115.57%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0;
        padding: 0;
    }
`;

const ImageContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: radial-gradient(37.24% 47.13% at 50% 0%, #051829 0%, rgba(1, 4, 6, 0.00) 100%);
    backdrop-filter: blur(0px);
    padding: 2rem;
`;

const ImageWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    padding: 2rem 1rem;
`;

const Cards = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 1.5rem;
    width: 100%;
`;

const Card = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    border-radius: 14.151px;
    width: 15%;
    height: auto;
    padding: 2rem 1rem;
    position: relative;
    background: #252216;
    background-clip: padding-box;
    border: 2px solid transparent;
    text-align: center;

    p {
        color: #FFF;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
        margin: 0;
    }

    img {
        width: 50%;
    }

    ::after {
        position: absolute;
        top: -2.653px; bottom: -2.653px;
        left: -2.653px; right: -2.653px;
        /* background: linear-gradient(150deg, #FEBA3B, #252216 35%, #252216, #FEBA3B); */
        background: linear-gradient(125deg,#FEBA3B,#252216 25%,#252216, #252216 70%, #FEBA3B);
        content: '';
        z-index: -1;
        border-radius: 14.151px;
    }
`;

const PriceBreakDown = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem 0;
    position: relative;
`;

const MonthlyPrize = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 2rem;
    padding: 3rem 0;
    text-align: center;

    p {
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 107.7%; /* 21.54px */
        letter-spacing: 1px;
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 115.57%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0;
    }

    img {
        width: 40%;
    }
`;

const TermsAndCondition = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items:  center;
    flex-direction: column;
    gap: 2rem;
    padding: 1rem 0 2rem 0;

    li {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 180%; /* 28.8px */
        text-transform: capitalize;
    }
`;

const BottomContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: radial-gradient(37.24% 47.13% at 50% 0%, #051829 0%, rgba(1, 4, 6, 0.00) 100%);
    backdrop-filter: blur(0px);
    padding: 1rem 0 2rem 0;

    p {
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 24px */
        text-transform: capitalize;
    }
`;

const Divider = styled.div`
    height: 2px;
    width: 100%;
    background: radial-gradient(#1182C1 0%, #00000000 60%);
`;

const UnderLine = styled.div`
    height: 2px;
    width: 184px;
    background: radial-gradient(#FFF 0%, rgba(153, 153, 153, 0.00) 80%);
`;

const SliderWrapper = styled.div`
    width: 85%;
    margin: 0 auto;

    .slick-slide {
        padding: 0 15px;
    }

    .slick-slide img {
        display: block;
        width: 100%;
        transition: transform .5s; /* Animation */

        :hover {
            transform: scale(0.8);
            border: 2px solid #FED546;
            border-radius: 1rem;
        }

        :focus-visible {
            outline: none;
        }
        :focus {
            outline: none;
        }
    }

    .slick-prev {
        left: -65px;
        top: 43%;
    }

    .slick-next {
        right: -25px;
        top: 43%;
    }

    .slick-prev:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/prevSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-next:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/nextSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-dots {
        bottom: -40px;

        li button:before {
            color: #fff;
            font-size: 15px;
            opacity: unset;
        }

        li.slick-active button:before {
            opacity: unset;
            color: ${theme('palette.slickActiveButtonClr')};
        }
    }
`;